import { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import MainLayout from '../components/layout/MainLayout';
import AppHeader from '../components/layout/AppHeader';
import LegalDocumentPanel from '../components/legal/LegalDocumentPanel';
import { termsBgSrc } from '../assets/legal';
import { TERMS_CONTENT_HTML } from '../config/termsContentHtml';
import { clearAuthSession, isAuthenticated } from '../storage/authStorage';

export default function TermsConditionsPage() {
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const authenticated = isAuthenticated();

  const handleConfirmLogout = () => {
    clearAuthSession();
    window.location.href = '/';
  };

  return (
    <MainLayout>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${termsBgSrc})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ px: { md: '50px' }, flexShrink: 0 }}>
          <AppHeader
            endVariant="profile"
            onLogoutClick={authenticated ? () => setLogoutDialogOpen(true) : undefined}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'flex-end',
            px: { xs: 0, sm: 2, md: 3 },
            pb: 0,
            mt: { xs: 1, md: 2 },
          }}
        >
          <LegalDocumentPanel
            title="Terms & Conditions"
            htmlContent={TERMS_CONTENT_HTML}
          />
        </Box>
      </Box>

      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            bgcolor: '#1a0834',
            border: '1px solid #ff66f766',
            color: '#fff',
            minWidth: { xs: '90%', sm: 380 },
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: '#fff' }}>Logout</DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#e6d4ff' }}>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setLogoutDialogOpen(false)} sx={{ color: '#e6d4ff', textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmLogout}
            variant="contained"
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #822AFF 0%, #FF00F2 100%)',
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </MainLayout>
  );
}
